import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Controller } from 'react-hook-form';

export default function PhoneInputController({ name, Details, control, rules, ...rest }) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={`${Details?.name}`}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <>
          <PhoneInput
            {...rest}
            country={'sg'} // default country, you can change
            value={field.value}
            onChange={(phone) => field.onChange(phone)}
            inputStyle={{
              width: '100%',
              borderColor: error ? 'red' : '#ccc',
              height : '55px'
            }}
            specialLabel="" // remove default label if you want
          />
          {/* {error && <span style={{ color: 'red', fontSize: '12px' }}>{error.message}</span>} */}
        </>
      )}
    />
  );
}
